import { ProfileConfig, Profile } from '@foxcorp/foxkit-profile-js';
import Cookies from 'universal-cookie';
import { createApiTokenHandler } from './Api/RefreshTokenHandler';
import { getDefaultConfig } from './Store';
import { getAccessToken } from './UserCookie';

//Helpers related to ProfileSDK

const cookies = new Cookies();

let profile = {};

export const profileSDK = () => profile;

const apisExcludedFromRefreshTokenHandling = ['checkRefreshToken', 'login', 'logout', 'createPaymentAccount'];

export const createProfile = () => {
  const { lastKnownProfileIdCookieName, appVersion, appEnv, accountApiKey, foxApi } = getDefaultConfig();

  const config = {
    apiKey: accountApiKey, // your api key
    baseUrl: foxApi,
    environment: appEnv, // development, qa, staging, production
    accessToken: getAccessToken(), // optional user accessToken, otherwise undefined
    profileId: cookies.get(lastKnownProfileIdCookieName), // optional user profileId, otherwise undefined
    appName: 'fox-nation-commerce', // required - your app name, e.g. 'Fox Now',
    appVersion, // required - your app version
    httpClientTimeout: 10000, // the number of milliseconds before an http request times out
  };

  for (const key of Object.getOwnPropertyNames(Profile.prototype)) {
    if (apisExcludedFromRefreshTokenHandling.includes(key)) continue;
    const originalMethod = Profile.prototype[key];
    Profile.prototype[key] = function () {
      return createApiTokenHandler(() => originalMethod.apply(this, arguments));
    };
  }

  const profileConfig = new ProfileConfig(config);
  profile = new Profile(profileConfig);
};
